<template>
  <div class="card border-0 shadow-sm rounded-4 mb-3 overflow-hidden">
    <div class="card-body p-3 bg-white">
      <!-- 1-qator: Mijoz, Usta -->
      <div class="row g-2 mb-2">
        <div class="col-12 col-md-6">
          <label class="small text-muted mb-1 d-block">Mijoz</label>
          <div class="d-flex align-items-center gap-1">
            <v-select
              :value="form.kontragent_id"
              :options="clientList"
              :reduce="c => c.id"
              label="name"
              :clearable="true"
              :filter="filterClient"
              :append-to-body="true"
              :calculate-position="withPopper"
              placeholder="Mijoz qidiring..."
              class="vsel-mijoz flex-grow-1"
              @input="onClientSelect"
            >
              <template #option="{ name, phone_number }">
                <div class="vsel-option">
                  <span class="vsel-name">{{ name }}</span>
                  <span v-if="phone_number" class="vsel-phone">{{ phone_number }}</span>
                </div>
              </template>
              <template #no-options="{ search }">
                <em v-if="search">"{{ search }}" — topilmadi</em>
                <em v-else>Mijoz mavjud emas</em>
              </template>
            </v-select>
            <button type="button" class="btn-plus" @click="openClientModal" title="Yangi mijoz">+</button>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <label class="small text-muted mb-1 d-block">Usta</label>
          <select :value="form.master_user_id" class="form-control-modern" @change="onMasterChange">
            <option :value="null">Tanlanmagan</option>
            <option v-for="u in ustaList" :key="u.id" :value="u.id">
              {{ u.name }} ({{ u.bonus || u.percent || 0 }}%)
            </option>
          </select>
        </div>
      </div>

      <!-- 2-qator: Savatlar, Narx turi -->
      <div class="row g-2 mb-2">
        <div class="col-12 col-md-6">
          <label class="small text-muted mb-1 d-block">Savatlar (Ojdaniya)</label>
          <button
            type="button"
            class="btn-baskets w-100"
            @click="$emit('toggle-baskets')"
          >
            <span class="basket-icon">&#128722;</span>
            Savatlar
            <span v-if="bronList.length > 0" class="basket-count">{{ bronList.length }}</span>
          </button>
        </div>
        <div class="col-12 col-md-6">
          <label class="small text-muted mb-1 d-block">Narx turi</label>
          <select :value="saleType" class="form-control-modern" @change="onSaleTypeChange">
            <option value="chakana">Chakana</option>
            <option value="optom">Optom</option>
          </select>
        </div>
      </div>

      <!-- 3-qator: Izoh, Yangi savat -->
      <div class="row g-2">
        <div class="col-12 col-md-6">
          <label class="small text-muted mb-1 d-block">Izoh</label>
          <input
            type="text"
            :value="form.comment"
            @input="emit('comment', $event.target.value)"
            class="form-control-modern"
            placeholder="Izoh..."
          >
        </div>
        <div class="col-12 col-md-6">
          <label class="small text-muted mb-1 d-block">&nbsp;</label>
          <button
            type="button"
            class="btn-new-basket w-100"
            @click="$emit('new-basket')"
            title="Yangi bo'sh savat ochish"
          >
            <span class="basket-plus">+</span> Yangi savat
          </button>
        </div>
      </div>
    </div>

    <!-- Yangi mijoz modali -->
    <b-modal ref="clientModal" title="Yangi mijoz qo'shish" hide-footer centered modal-class="client-modal-modern">
      <div class="client-modal-body">
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="text-primary">&#128100;</i> F.I.O <span class="text-danger">*</span>
          </label>
          <input
            ref="nameInput"
            v-model="newClient.name"
            type="text"
            class="form-control form-control-lg"
            placeholder="Familiya Ism Otasining ismi"
            maxlength="50"
            @keyup.enter="focusPhone"
          >
        </div>
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="text-primary">&#128222;</i> Telefon <span class="text-danger">*</span>
          </label>
          <input
            ref="phoneInput"
            :value="newClient.phone_number"
            type="tel"
            class="form-control form-control-lg"
            placeholder="+998 (90) 123-45-67"
            maxlength="19"
            @input="onPhoneInput"
            @focus="onPhoneFocus"
            @keyup.enter="saveClient"
          >
        </div>
        <div class="mb-4">
          <label class="form-label fw-semibold d-block">
            <i class="text-primary">&#128181;</i> Narx turi
          </label>
          <div class="sale-type-toggle">
            <button
              type="button"
              class="sale-type-btn"
              :class="{ active: newClient.sale_type === 'chakana' }"
              @click="newClient.sale_type = 'chakana'"
            >
              <span class="sale-type-icon">&#128722;</span>
              <span>Chakana</span>
            </button>
            <button
              type="button"
              class="sale-type-btn"
              :class="{ active: newClient.sale_type === 'optom' }"
              @click="newClient.sale_type = 'optom'"
            >
              <span class="sale-type-icon">&#128230;</span>
              <span>Optom</span>
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-light" @click="$refs.clientModal.hide()">Bekor</button>
          <button type="button" class="btn btn-primary px-4" @click="saveClient" :disabled="savingClient">
            <span v-if="savingClient"><span class="spinner-border spinner-border-sm me-1"></span>Saqlanmoqda...</span>
            <span v-else>Saqlash</span>
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Yangi avtomobil modali -->
    <b-modal ref="carModal" title="Yangi avtomobil qo'shish" hide-footer centered>
      <div class="mb-3">
        <label class="form-label">Brand <span class="text-danger">*</span></label>
        <select v-model="newCar.brand_id" class="form-control" @change="onBrandSelect">
          <option :value="null">Tanlang...</option>
          <option v-for="b in brands" :key="b.id" :value="b.id">{{ b.name }}</option>
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label">Model</label>
        <select v-model="newCar.model_id" class="form-control" :disabled="!newCar.brand_id">
          <option :value="null">Tanlang...</option>
          <option v-for="m in models" :key="m.id" :value="m.id">{{ m.name }}</option>
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label">Davlat raqami <span class="text-danger">*</span></label>
        <input v-model="newCar.car_number" type="text" class="form-control" placeholder="01 A 123 AA" maxlength="20">
      </div>
      <div class="row g-2 mb-3">
        <div class="col-6">
          <label class="form-label">Rang</label>
          <input v-model="newCar.color" type="text" class="form-control" placeholder="Oq, Qora..." maxlength="50">
        </div>
        <div class="col-6">
          <label class="form-label">Yil</label>
          <input v-model.number="newCar.year" type="number" class="form-control" placeholder="2024" min="1900" max="2030">
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary btn-sm" @click="$refs.carModal.hide()">Bekor</button>
        <button type="button" class="btn btn-primary btn-sm" @click="saveCar" :disabled="savingCar">
          {{ savingCar ? 'Saqlanmoqda...' : 'Saqlash' }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SaleHeaderBar',
  props: {
    form:       { type: Object, required: true },
    clientList: { type: Array,  default: () => [] },
    ustaList:   { type: Array,  default: () => [] },
    bronList:   { type: Array,  default: () => [] },
    clientCars: { type: Array,  default: () => [] },
    saleType:   { type: String, default: 'chakana' },
  },
  data() {
    return {
      selectedCarId: null,
      // Yangi mijoz
      newClient: { name: '', phone_number: '+998', sale_type: 'chakana' },
      savingClient: false,
      // Yangi avto
      newCar: { brand_id: null, model_id: null, car_number: '', color: '', year: null },
      savingCar: false,
      brands: [],
      models: [],
    };
  },
  emits: ['update:form', 'client-changed', 'master-changed', 'bron-selected', 'car-selected', 'client-added', 'car-added', 'sale-type-changed', 'toggle-baskets', 'new-basket'],
  methods: {
    emit(key, value) {
      this.$emit('update:form', { ...this.form, [key]: value });
    },
    carLabel(car) {
      const parts = [];
      if (car.brand?.name) parts.push(car.brand.name);
      if (car.model?.name) parts.push(car.model.name);
      if (car.car_number) parts.push(car.car_number);
      return parts.join(' ') || `Avto #${car.id}`;
    },
    onClientChange(e) {
      const val = e.target.value ? Number(e.target.value) : null;
      this.selectedCarId = null;
      this.$emit('update:form', { ...this.form, kontragent_id: val, car_number: '' });
      this.$emit('client-changed', val);
    },
    onClientSelect(val) {
      // v-select :reduce orqali id qaytaradi (yoki null — clearable)
      const id = val ? Number(val) : null;
      this.selectedCarId = null;
      this.$emit('update:form', { ...this.form, kontragent_id: id, car_number: '' });
      this.$emit('client-changed', id);
    },
    // Mijozni nom + telefon bo'yicha qidirish
    filterClient(options, search) {
      const q = String(search || '').toLowerCase().trim();
      if (!q) return options;
      const digits = q.replace(/\D/g, '');
      return options.filter(o => {
        const name = String(o.name || '').toLowerCase();
        const phone = String(o.phone_number || '').replace(/\D/g, '');
        return name.includes(q) || (digits && phone.includes(digits));
      });
    },
    // v-select dropdownni body'ga chiqarib, parent overflow:hidden ostidan qutqaramiz.
    // appendToBody bilan ishlatish uchun calculate-position kerak.
    withPopper(dropdownList, component, { width }) {
      const toggle = component.$refs.toggle;
      if (!toggle) return () => {};
      const rect = toggle.getBoundingClientRect();
      dropdownList.style.position = 'absolute';
      dropdownList.style.width = width;
      dropdownList.style.top = `${rect.bottom + window.scrollY}px`;
      dropdownList.style.left = `${rect.left + window.scrollX}px`;
      dropdownList.style.zIndex = '99999';
      return () => {};
    },
    onCarChange(e) {
      const val = e.target.value ? Number(e.target.value) : null;
      this.selectedCarId = val;
      const car = val ? this.clientCars.find(c => c.id === val) : null;
      if (car) {
        this.$emit('update:form', { ...this.form, car_number: car.car_number || '' });
      } else {
        this.$emit('update:form', { ...this.form, car_number: '' });
      }
      this.$emit('car-selected', car);
    },
    onMasterChange(e) {
      const val = e.target.value ? Number(e.target.value) : null;
      this.$emit('update:form', { ...this.form, master_user_id: val });
      this.$emit('master-changed', val);
    },
    onBronChange(e) {
      const val = e.target.value ? Number(e.target.value) : null;
      this.$emit('update:form', { ...this.form, bron_id: val });
      this.$emit('bron-selected', val);
    },

    onSaleTypeChange(e) {
      this.$emit('sale-type-changed', e.target.value);
    },

    // === Yangi mijoz ===
    openClientModal() {
      this.newClient = { name: '', phone_number: '', sale_type: 'chakana' };
      this.$refs.clientModal.show();
      this.$nextTick(() => {
        setTimeout(() => this.$refs.nameInput && this.$refs.nameInput.focus(), 200);
      });
    },
    focusPhone() {
      if (!this.newClient.name || this.newClient.name.trim().length < 3) {
        return alert("F.I.O kamida 3 ta belgi bo'lishi kerak!");
      }
      if (!this.newClient.phone_number) {
        this.newClient.phone_number = '+998 ';
      }
      this.$nextTick(() => {
        const el = this.$refs.phoneInput;
        if (el) {
          el.focus();
          const len = el.value.length;
          el.setSelectionRange(len, len);
        }
      });
    },
    formatUzPhone(raw) {
      let digits = String(raw || '').replace(/\D/g, '');
      if (digits.startsWith('998')) digits = digits.slice(3);
      digits = digits.slice(0, 9);
      if (!digits) return '';
      let out = '+998';
      if (digits.length > 0) out += ' (' + digits.slice(0, 2);
      if (digits.length >= 2) out += ') ';
      if (digits.length >= 3) out += digits.slice(2, 5);
      if (digits.length >= 6) out += '-' + digits.slice(5, 7);
      if (digits.length >= 8) out += '-' + digits.slice(7, 9);
      return out;
    },
    onPhoneFocus() {
      if (!this.newClient.phone_number) {
        this.newClient.phone_number = '+998 ';
      }
    },
    onPhoneInput(e) {
      const formatted = this.formatUzPhone(e.target.value);
      this.newClient.phone_number = formatted;
      this.$nextTick(() => {
        if (this.$refs.phoneInput) {
          this.$refs.phoneInput.value = formatted;
          const len = formatted.length;
          this.$refs.phoneInput.setSelectionRange(len, len);
        }
      });
    },
    async saveClient() {
      if (!this.newClient.name || this.newClient.name.trim().length < 3) {
        return alert("F.I.O kamida 3 ta belgi bo'lishi kerak!");
      }
      const digits = String(this.newClient.phone_number || '').replace(/\D/g, '');
      if (digits.length !== 12 || !digits.startsWith('998')) {
        return alert("Telefon raqamini to'liq kiriting! (+998 XX XXX-XX-XX)");
      }
      this.savingClient = true;
      try {
        const sklad_id = Number(localStorage.getItem('sklad_id')) || 1;
        const res = await axios.post('api/v1/kontragent/', {
          name: this.newClient.name.trim(),
          phone_number: this.newClient.phone_number.trim(),
          type: 1,
          sklad_id,
          sale_type: this.newClient.sale_type || 'chakana',
          comment: ' ',
        });
        const created = res.data?.data || res.data;
        this.$refs.clientModal.hide();
        this.$emit('client-added', created);
      } catch (e) {
        alert("Xatolik: " + (e.response?.data?.message || "Mijozni saqlashda xato"));
      } finally {
        this.savingClient = false;
      }
    },

    // === Yangi avtomobil ===
    openCarModal() {
      this.newCar = { brand_id: null, model_id: null, car_number: '', color: '', year: null };
      this.models = [];
      if (this.brands.length === 0) this.fetchBrands();
      this.$refs.carModal.show();
    },
    async fetchBrands() {
      try {
        const res = await axios.get('api/v1/brand/');
        this.brands = res.data?.data || res.data || [];
      } catch (e) { this.brands = []; }
    },
    async onBrandSelect() {
      this.newCar.model_id = null;
      this.models = [];
      if (!this.newCar.brand_id) return;
      try {
        const res = await axios.get('api/v1/model/', { params: { brand_id: this.newCar.brand_id } });
        this.models = res.data?.data || res.data || [];
      } catch (e) { this.models = []; }
    },
    async saveCar() {
      if (!this.newCar.brand_id) {
        return alert("Brandni tanlang!");
      }
      if (!this.newCar.car_number || this.newCar.car_number.trim().length < 2) {
        return alert("Davlat raqamini kiriting!");
      }
      this.savingCar = true;
      try {
        const payload = {
          kontragent_id: this.form.kontragent_id,
          brand_id: this.newCar.brand_id,
          model_id: this.newCar.model_id,
          car_number: this.newCar.car_number.trim(),
          color: this.newCar.color?.trim() || '',
          year: this.newCar.year || null,
        };
        const res = await axios.post('api/v1/client-profile/cars', payload);
        const created = res.data?.data || res.data;
        this.$refs.carModal.hide();
        this.$emit('car-added', created);
      } catch (e) {
        alert("Xatolik: " + (e.response?.data?.message || "Avtomobilni saqlashda xato"));
      } finally {
        this.savingCar = false;
      }
    },
  },
  watch: {
    clientCars() {
      this.selectedCarId = null;
    },
  },
}
</script>

<style scoped>
.form-control-modern {
  border: 1px solid #e0e6ed;
  border-radius: 10px;
  padding: 8px 12px;
  width: 100%;
  font-size: 0.85rem;
  transition: all 0.3s;
  background: white;
}
.form-control-modern:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  outline: none;
}
.form-control-modern:disabled {
  background: #f5f5f5;
  color: #999;
}
.btn-plus {
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 10px;
  border: 1px solid #3b82f6;
  background: #3b82f6;
  color: white;
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.btn-plus:hover {
  background: #2563eb;
  border-color: #2563eb;
}
.btn-plus:disabled {
  background: #cbd5e1;
  border-color: #cbd5e1;
  cursor: not-allowed;
}
.btn-baskets {
  border: 1px solid #e0e6ed;
  border-radius: 10px;
  padding: 7px 12px;
  font-size: 0.85rem;
  font-weight: 600;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #334155;
}
.btn-baskets:hover {
  border-color: #f59e0b;
  background: #fffbeb;
}
.btn-new-basket {
  border: 1px solid #10b981;
  border-radius: 10px;
  padding: 7px 12px;
  font-size: 0.85rem;
  font-weight: 700;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
}
.btn-new-basket:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
}
.basket-plus {
  font-size: 1.1rem;
  font-weight: 900;
  line-height: 1;
}
.basket-icon { font-size: 1rem; }
.sale-type-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.sale-type-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  border: 2px solid #e0e6ed;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.95rem;
  color: #64748b;
  transition: all 0.2s;
}
.sale-type-btn:hover {
  border-color: #93c5fd;
  color: #3b82f6;
}
.sale-type-btn.active {
  border-color: #3b82f6;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}
.sale-type-icon {
  font-size: 1.25rem;
}
.client-modal-body .form-control-lg {
  border-radius: 10px;
  border: 1px solid #e0e6ed;
  font-size: 0.95rem;
}
.client-modal-body .form-control-lg:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.client-modal-body .form-label {
  font-size: 0.85rem;
  color: #334155;
  margin-bottom: 6px;
}
.basket-count {
  background: #ef4444;
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}

/* Mijoz uchun qidiruvli v-select */
.vsel-mijoz ::v-deep .vs__dropdown-toggle {
  border: 1px solid #e0e6ed;
  border-radius: 10px;
  padding: 1px 4px;
  min-height: 34px;
  background: white;
}
.vsel-mijoz.vs--open ::v-deep .vs__dropdown-toggle,
.vsel-mijoz ::v-deep .vs__dropdown-toggle:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.vsel-mijoz ::v-deep .vs__search,
.vsel-mijoz ::v-deep .vs__search:focus {
  font-size: 0.85rem;
  padding: 4px 6px;
  margin: 0;
}
.vsel-mijoz ::v-deep .vs__selected {
  font-size: 0.85rem;
  margin: 2px 4px;
  padding: 0;
  color: #1e293b;
}
.vsel-mijoz ::v-deep .vs__actions {
  padding: 0 6px;
}
.vsel-mijoz ::v-deep .vs__dropdown-menu {
  border-radius: 10px;
  font-size: 0.85rem;
  max-height: 280px;
}
/* appendToBody bilan dropdown body'ga ko'chadi — scoped emas, global override kerak */
.vsel-option {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.vsel-name {
  font-weight: 600;
  color: #1e293b;
}
.vsel-phone {
  font-size: 0.72rem;
  color: #64748b;
}
</style>

<!-- appendToBody bilan dropdown body'ga ko'chadi — scoped CSS ishlamaydi, shu sababli global override -->
<style>
.vs__dropdown-menu {
  z-index: 99999 !important;
  border-radius: 10px;
  font-size: 0.85rem;
  max-height: 280px;
}
.vs__dropdown-menu .vsel-option {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.vs__dropdown-menu .vsel-name {
  font-weight: 600;
  color: #1e293b;
}
.vs__dropdown-menu .vsel-phone {
  font-size: 0.72rem;
  color: #64748b;
}
</style>
